import { GlobalAxios } from "./../axios/axios-config";
import {
  INewTicketAutomationReceivedSlot,
  ITicketAutomationReceivedSlot,
} from "../models/ticket-automation-received-slot";

const TICKET_AUTOMATION_RECEIVED_SLOT_ROUTE =
  process.env.REACT_APP_AUTOMATIONS + "/api/v1/TicketAutomationReceivedSlot/";

export const createTicketAutomationReceivedSlot = (
  item: INewTicketAutomationReceivedSlot
) => {
  return GlobalAxios.post(TICKET_AUTOMATION_RECEIVED_SLOT_ROUTE, item);
};

export const getTicketAutomationReceivedSlotById = (id: string) => {
  return GlobalAxios.get<ITicketAutomationReceivedSlot>(
    TICKET_AUTOMATION_RECEIVED_SLOT_ROUTE + id
  );
};

export const updateTicketAutomationReceivedSlotById = ({
  item,
  id,
}: {
  item: INewTicketAutomationReceivedSlot;
  id: string;
}) => {
  return GlobalAxios.put(TICKET_AUTOMATION_RECEIVED_SLOT_ROUTE + id, item);
};
